import React from "react";
import {
  Users,
  BriefcaseBusiness,
  FileText,
  ArrowLeftRight,
} from "lucide-react";

import StatCard from "../../shared/components/StatCard";

const EmploymentStats = ({ stats = {}, onActiveTypesClick }) => {
  const cards = [
    {
      key: "totalEmployees",
      title: "Total Employees",
      value: stats.totalEmployees ?? 0,
      icon: Users,
      iconColor: "text-white",
      iconBg: "bg-blue-600",
      trend: null,
      trendType: "positive",
      description: "this month",
    },
    {
      key: "activeEmploymentTypes",
      title: "Active Employment Types",
      value: stats.activeEmploymentTypes ?? 0,
      icon: BriefcaseBusiness,
      iconColor: "text-white",
      iconBg: "bg-purple-600",
      description: "Configured types",
      onClick: onActiveTypesClick,
    },
    {
      key: "activeContracts",
      title: "Active Contracts",
      value: stats.activeContracts ?? 0,
      icon: FileText,
      iconColor: "text-white",
      iconBg: "bg-emerald-600",
      trend: null,
      trendType: "positive",
      description: "active",
    },
    {
      key: "employmentChanges",
      title: "Employment Changes",
      value: stats.employmentChanges ?? 0,
      icon: ArrowLeftRight,
      iconColor: "text-white",
      iconBg: "bg-orange-500",
      description: "This month",
    },
  ];

  return (
    <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 xl:grid-cols-4">
      {cards.map((card) => (
        <StatCard
          key={card.key}
          title={card.title}
          value={card.value}
          icon={card.icon}
          iconColor={card.iconColor}
          iconBg={card.iconBg}
          trend={card.trend}
          trendType={card.trendType}
          description={card.description}
          onClick={card.onClick}
        />
      ))}
    </div>
  );
};

export default EmploymentStats;